import { useContext, useState, useEffect } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const SocialMedia = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, socialMedia: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}
	
	const steps = [
		{
			target: '.socialMediaFirstStep',
			title: "Connect Your Socials",
			content: 'Choose where you want to connect from your socials.',
			disableBeacon: true,
			placement: "right",
		},
		{
			target: '.socialMediaSecondStep',
			title: "Create Connecton",
			content: "Click to connect to your chosen social platform.",
			disableBeacon: true,
			placement: "left"
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.socialMediaFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.socialMedia)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="socialMedia" 
			featureName="reports"
		/>
	);
}
